import { getAdminUser } from '@nesso/identity-contracts/user.queries';

export const adminUserSchema = getAdminUser.output;
